
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pricing/[[...slug]]",
      function () {
        return require("private-next-pages/pricing/[[...slug]].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pricing/[[...slug]]"])
      });
    }
  